module.exports = __webpack_public_path__ + "img/jkkp.6e094ac5.png";